export const MIN_GPS_DISTANCE = 0;
export const MAX_GPS_DISTANCE = 10;
